import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
// Deve stare dopo gli stili di @mantine/core: senza questo foglio i calendari
// (DatePickerInput) vengono renderizzati senza stile — frecce enormi, griglia
// dei giorni disallineata, intestazione del mese mancante.
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import App from './App';
import './index.css';
import { initFrontendLogging } from '@/utils/logger';

initFrontendLogging();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
